import { render, staticRenderFns } from "./TabsDashboardPayment.vue?vue&type=template&id=c70a82ae&"
import script from "./TabsDashboardPayment.vue?vue&type=script&lang=js&"
export * from "./TabsDashboardPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports